export function initMegaMenu() {
	const header = document.querySelector('.diakon-header');
	if (!header) {
		return;
	}

	const panels = [...document.querySelectorAll('.diakon-mega-menu__panel')];
	if (!panels.length) {
		return;
	}

	// Move panels to the header so position:absolute; top:100% is relative to it.
	// This is the desktop panel only — below the breakpoint the mobile menu
	// renders the same menu as a nested list of its own.
	panels.forEach((panel) => header.appendChild(panel));

	const closeAll = () => {
		panels.forEach((p) => {
			p.classList.remove('is-open');
			p.setAttribute('aria-hidden', 'true');
		});
		document.querySelectorAll('[data-mega-menu-trigger]').forEach((t) => {
			t.setAttribute('aria-expanded', 'false');
		});
	};

	document.querySelectorAll('[data-mega-menu-trigger]').forEach((trigger) => {
		const slug = trigger.dataset.megaMenuTrigger;
		const panel = header.querySelector(`[data-mega-menu="${slug}"]`);
		if (!panel) {
			return;
		}

		const li = trigger.closest('.diakon-mega-menu-item');

		const openPanel = () => {
			closeAll();
			panel.classList.add('is-open');
			panel.setAttribute('aria-hidden', 'false');
			trigger.setAttribute('aria-expanded', 'true');
		};

		const closePanel = () => {
			panel.classList.remove('is-open');
			panel.setAttribute('aria-hidden', 'true');
			trigger.setAttribute('aria-expanded', 'false');
		};

		// Toggle on chevron button click.
		trigger.addEventListener('click', (e) => {
			e.stopPropagation();
			const isOpen = trigger.getAttribute('aria-expanded') === 'true';
			if (isOpen) {
				closePanel();
			} else {
				openPanel();
			}
		});

		// Respect the navigation block's "Submenu Visibility" setting.
		// PHP sets open-on-hover-click or open-on-click on the <li> from block context.
		const isHoverEnabled = li?.classList.contains('open-on-hover-click');

		if (isHoverEnabled && li) {
			let closeTimer;

			li.addEventListener('mouseenter', () => {
				clearTimeout(closeTimer);
				openPanel();
			});

			li.addEventListener('mouseleave', () => {
				closeTimer = setTimeout(closePanel, 200);
			});

			panel.addEventListener('mouseenter', () =>
				clearTimeout(closeTimer)
			);
			panel.addEventListener('mouseleave', () => {
				closeTimer = setTimeout(closePanel, 200);
			});
		}
	});

	// Close on Escape.
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeAll();
		}
	});

	// Close when clicking anywhere that is not the panel itself or a trigger button.
	// stopPropagation on trigger clicks keeps this from firing for toggle interactions.
	document.addEventListener('click', (e) => {
		if (
			!e.target.closest('.diakon-mega-menu__panel') &&
			!e.target.closest('[data-mega-menu-trigger]')
		) {
			closeAll();
		}
	});
}
